import { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Play, Quote } from 'lucide-react';
import { VIDEO_STORIES, WRITTEN_STORY } from './retreatsData';

export const TransformationStories = () => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? VIDEO_STORIES : VIDEO_STORIES.slice(0, 3);

  return (
    <section id="stories" className="py-20 px-6 bg-gradient-to-b from-cream to-white" data-testid="transformation-stories">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <Badge className="bg-terracotta/10 text-terracotta mb-4">Transformation Stories</Badge>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-forest mb-4 leading-tight">
            They Came for the Retreat.<br />
            <span className="text-terracotta">They Left With Something More.</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-10 mb-12 justify-items-center">
          {visible.map((vimeoId, index) => (
            <div key={vimeoId} className="group relative" data-testid={`story-video-${index}`}>
              <div className="relative bg-gradient-to-b from-gray-800 via-gray-900 to-black rounded-[2.5rem] p-2 shadow-2xl transform transition-all duration-500 hover:scale-105">
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-6 bg-black rounded-b-2xl z-10 flex items-center justify-center">
                  <div className="w-12 h-3 bg-gray-800 rounded-full"></div>
                </div>
                <div className="relative bg-black rounded-[2rem] overflow-hidden" style={{ width: '200px', height: '380px' }}>
                  <iframe
                    src={`https://player.vimeo.com/video/${vimeoId}?h=&title=0&byline=0&portrait=0&background=0`}
                    className="absolute inset-0 w-full h-full object-cover"
                    style={{ transform: 'scale(1.02)' }}
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    title={`Transformation story ${index + 1}`}
                  ></iframe>
                </div>
                <div className="flex justify-center py-2">
                  <div className="w-24 h-1 bg-gray-600 rounded-full"></div>
                </div>
              </div>
              <p className="mt-4 text-sm font-medium text-forest flex items-center justify-center gap-2">
                <Play className="h-3 w-3 text-terracotta" /> Sister Diamond Story
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mb-14">
          <Button
            variant="outline"
            onClick={() => setShowAll(!showAll)}
            className="border-2 border-forest text-forest hover:bg-forest hover:text-white transition-all duration-300 px-8 py-3 rounded-full font-medium"
            data-testid="toggle-stories-btn"
          >
            {showAll ? 'Show Less' : `View More Stories (${VIDEO_STORIES.length - 3} more)`}
          </Button>
        </div>

        <div className="max-w-3xl mx-auto bg-white rounded-2xl border border-sand shadow-sm p-8 text-center">
          <Quote className="h-8 w-8 text-terracotta/40 mx-auto mb-4" />
          <p className="text-gray-700 text-lg italic leading-relaxed mb-6">"{WRITTEN_STORY.quote}"</p>
          <div className="flex items-center justify-center gap-3">
            <div className="h-12 w-12 rounded-full bg-terracotta text-white flex items-center justify-center font-heading font-bold text-lg">UW</div>
            <div className="text-left">
              <p className="font-heading font-bold text-forest">{WRITTEN_STORY.name}</p>
              <p className="text-sm text-gray-500">{WRITTEN_STORY.title}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
